import React from 'react';
import { FadeIn, Button } from './Shared';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-32 overflow-hidden bg-brand-cream" data-id="element-120">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-121">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-122">
          <FadeIn data-id="element-123">
            <div className="max-w-2xl" data-id="element-124">
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-brand-rose/20 text-brand-teal font-medium text-sm mb-8" data-id="element-125">
                <span className="flex h-2 w-2 rounded-full bg-brand-teal mr-2" data-id="element-126"></span>
                Programa de 21 Días
              </div>
              <h1 className="text-5xl lg:text-6xl font-heading font-bold text-brand-teal leading-tight mb-6" data-id="element-127">
                El Protocolo de "Desconexión Segura": Recupera tu Identidad y tu
                Poder en 21 Días
              </h1>
              <p className="text-xl text-brand-charcoal/80 mb-10 leading-relaxed" data-id="element-128">
                Deja de sobrevivir a la ruptura y empieza a liderar tu nueva
                vida independiente sin mirar atrás.
              </p>
              <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full sm:w-auto group" data-id="element-129">
                Obtén Acceso Inmediato
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-130" />
              </Button>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-131">
            <div className="relative" data-id="element-132">
              <div className="absolute inset-0 bg-brand-gold/20 rounded-3xl transform rotate-3 scale-105" data-id="element-133"></div>
              <img src="https://cdn.magicpatterns.com/uploads/xAEijrKFWo86PJfvL1GNGT/heylloyd-image-1773889950286.png" alt="Mujer sintiéndose libre y en paz" className="relative rounded-3xl shadow-2xl w-full h-auto" data-id="element-134" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}